<!-- eslint-disable vue/no-reserved-component-names -->
<template>
    <div class="mx-auto">
        <div class="card mx-auto shadow-sm p-5 pb-2 border-0 bg-light mb-5">
            <h2 v-if="$broker" class="">{{ $t('step1.broker') }} {{ $broker.brokerCompanyName }}</h2>
            <h2 class="text-header form-section__title">
                {{ $t('step1.policyHolderTitle') }}
            </h2>

            <div class="form-section">
                <h4 class="form-section__title">
                    {{ $t('previewForm.details') }}
                </h4>
                <PolicyHolderDetail class="form-section__field" />

                <div class="col-md-12 form-section__field">
                    <div class="d-flex justify-content-start">
                        <label for="policyHolderInsured-yes">
                            <div v-for="(item, index) in $root.t('step1.isPolicyInsured')" :key="index">{{ item }}</div>
                        </label>
                    </div>
                    <div class="form-control">
                        {{ isPolicyHolderInsured }}
                    </div>
                </div>

                <div class="form-section__field">
                    <div class="form-section">
                        <div class="col-md-12 form-section__field">
                            <AppInput
                                name="PolicyHolder.StartTime"
                                :label="$root.t('step1.policyStartDate')"
                                rules="required|currencyPayIn"
                            >
                                <AppDatePicker v-model="form.policyDetails.policyStartDate" />
                            </AppInput>
                        </div>

                        <div class="col-md-12 form-section__field">
                            <AppInput
                                name="PolicyHolder.Currency"
                                :label="$root.t('step1.currencyPayIn')"
                                rules="required|appSelectRequired"
                            >
                                <AppSelect
                                    v-model="form.policyDetails.currencyId"
                                    :placeholder="$t('common.defaultSelectionValue')"
                                    :options="$optionData.currencies"
                                />
                            </AppInput>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-section">
                <h4 class="form-section__title">
                    {{ $t('previewForm.contact') }}
                </h4>
                <ContactDetail />
            </div>

            <div class="form-section" style="page-break-after: always">
                <h4 class="form-section__title">
                    {{ $t('previewForm.residence') }}
                </h4>
                <AddressForm
                    :form-data="additionalDetails.countryResidenceAddress"
                    :option-countries="$optionData.residenceCountries"
                    prefix="AddtionalDetails.ResidenceAddress."
                />
            </div>

            <div v-if="$formData.policyDetails.policyHolderInsured" class="form-section">
                <BmiForm
                    :form-data="additionalDetails.bmi"
                    prefix="policy-holder-summary"
                    :print="true"
                    :quote-verify="quoteVerify"
                    :dob="$formData.policyHolder.details.dateOfBirth"
                />
            </div>

            <div v-if="$formData.policyDetails.policyHolderInsured" class="form-section">
                <SupplementaryQuestionForm :additional-details="additionalDetails" :prefix="'policy-holder-gen'" />
            </div>

            <div class="form-section">
                <h4 class="form-section__title">
                    {{ $t('previewForm.home') }}
                </h4>
                <AddressForm
                    :form-data="additionalDetails.homeCountryAddress"
                    :option-countries="$optionData.residenceCountries"
                    prefix="AddtionalDetails.ResidenceAddress."
                />
            </div>

            <div
                v-if="$formData.policyDetails.policyHolderInsured"
                class="form-section"
                style="page-break-after: always"
            >
                <h4 class="form-section__title">
                    {{ $t('previewForm.physic') }}
                </h4>
                <PhysicalDetailsForm
                    :form-data="additionalDetails.physicianDetails"
                    prefix="policy-holder-gen"
                    :print="true"
                />
            </div>

            <div
                v-if="$formData.underwritingTypeId === 1 && $formData.policyDetails.policyHolderInsured"
                class="form-section"
                style="page-break-after: always"
            >
                <h4 class="form-section__title">
                    {{ $t('previewForm.underwritingQuestion') }}
                </h4>
                <div class="form-section__group">
                    <div class="accordion">
                        <div class="accordion-item mb-2 border">
                            <AccordionMemberForm
                                :underwriting-questions="$formData.underwritingQuestions"
                                :prefix="`0_print_policy_holder`"
                                title="Underwriting Question"
                                :print="true"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            v-if="form.familyMembers.length > 0"
            class="card mx-auto card shadow-sm border-0"
            style="page-break-after: always"
        >
            <FamilyMemberSummary :family-members="form.familyMembers" :quote-verify="quoteVerify" />
        </div>

        <SelectQuote :print="true" style="page-break-after: always" />
        <Summary class="card mx-auto" :print="true" />
    </div>
</template>

<script>
import PolicyHolderDetail from '../PolicyHolder/PolicyHolderDetail.vue'
import ContactDetail from '../PolicyHolder/ContactDetail.vue'

import AddressForm from '../../components/AdditionalDetails/Form/AddressForm.vue'
import BmiForm from '../../components/AdditionalDetails/Form/BmiForm.vue'
import SupplementaryQuestionForm from '../../components/AdditionalDetails/Form/SupplementaryQuestionForm.vue'
import PhysicalDetailsForm from '../../components/AdditionalDetails/Form/PhysicalDetailsForm.vue'

import FamilyMemberSummary from './FamilyMemberSummary.vue'
import AccordionMemberForm from '../UnderwritingQuestions/AccordionMemberForm.vue'
import SelectQuote from '../SelectQuote/index.vue'
import Summary from '../ConfirmAndBuy/index.vue'

export default {
    name: 'PolicyHolderSummary',
    components: {
        PolicyHolderDetail,
        ContactDetail,

        AddressForm,
        BmiForm,
        SupplementaryQuestionForm,
        PhysicalDetailsForm,
        AccordionMemberForm,

        FamilyMemberSummary,
        SelectQuote,
        // eslint-disable-next-line vue/no-reserved-component-names
        Summary,
    },
    props: {
        quoteVerify: {
            type: Object,
            require: true,
            default: null,
        },
    },
    data() {
        return {
            form: this.$formData,
            policyHolder: this.$formData.policyHolder,
            additionalDetails: this.$formData.policyHolder.additionalDetails,
        }
    },
    computed: {
        getCurrencySelected() {
            return this.$optionData.currencies.find((c) => c.value == this.form.policyDetails.currencyId).text
        },
        isPolicyHolderInsured() {
            return this.form.policyDetails.policyHolderInsured ? 'Yes' : 'No'
        },
    },
    watch: {},
    mounted() {
        this.$root.showSummaryComponent = true
        setTimeout(() => {
            this.$root.summaryOuterHtml = this.getRawHtml()
            this.$root.showSummaryComponent = false
        }, 2000)
    },
    methods: {
        getRawHtml() {
            let styleTags = document.head.getElementsByTagName('style')
            let styles = []
            for (let i = 0; i < styleTags.length; i++) {
                styles.push(styleTags[i].outerHTML)
            }
            return `${styles.join(' ')} 
    ${this.$el.outerHTML}`
        },
    },
}
</script>
<style lang="scss">
// .wrapper-input-form {
//   max-width: 1920px;
// }
</style>
